/**
 * 의존성 없는 CSV 내보내기.
 *
 * 관리자 v1(SalesPage)은 xlsx 를 쓰지만, owner-console-v2 는 번들을 가볍게 유지하려고
 * 표준 CSV 문자열 + Blob 다운로드로 처리한다. Excel 한글 깨짐 방지를 위해 UTF-8 BOM 을 붙인다.
 */

/** CSV 셀 이스케이프 — 쉼표/따옴표/개행이 있으면 따옴표로 감싸고 내부 따옴표는 두 번 */
function escapeCell(value) {
  const text = value == null ? '' : String(value);
  if (/[",\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

/**
 * rows: [{컬럼명: 값, ...}] — 첫 행의 키를 헤더로 쓴다.
 * 반환값은 브라우저에서 파일 다운로드를 트리거한다.
 */
export function downloadCsv(filename, rows) {
  if (!Array.isArray(rows) || rows.length === 0) return false;

  const headers = Object.keys(rows[0]);
  const lines = [
    headers.map(escapeCell).join(','),
    ...rows.map((row) => headers.map((key) => escapeCell(row[key])).join(',')),
  ];
  const csv = `﻿${lines.join('\r\n')}`; // BOM + CRLF (Excel 호환)

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  return true;
}
